import { Skeleton } from "@mui/material";
import React from "react";

const CollectionCardSkeleton = () => {
  return (
    <Skeleton
      variant="rectangular"
      color="#eee"
      width={"100%"}
      height={230}
      style={{ borderRadius: "10px", marginBottom: "20px" }}
    />
  );
};

export default CollectionCardSkeleton;
